module.exports = "/static/assets/4ef9378078d331db8fa055d21aee5e5b.gif";